import {fromJS} from 'immutable';

import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAILURE,
  USER_GET_PROFILE_REQUEST,
  USER_GET_PROFILE_SUCCESS,
  USER_GET_PROFILE_FAILURE,
  USER_SAVE_PROFILE_REQUEST,
  USER_SAVE_PROFILE_SUCCESS,
  USER_SAVE_PROFILE_FAILURE,
  USER_CHANGE_PASSWORD_REQUEST,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAILURE,
  USER_RESET_DATA,
  USER_SIGNUP_REQUEST,
  USER_SIGNUP_SUCCESS,
  USER_SIGNUP_FAILURE,
  USER_NEWSLETTER_REQUEST,
  USER_NEWSLETTER_SUCCESS,
  USER_NEWSLETTER_FAILURE,
  USER_RESET_PASSWORD_REQUEST,
  USER_RESET_PASSWORD_SUCCESS,
  USER_RESET_PASSWORD_FAILURE,
  USER_ADD_ADDRESS_REQUEST,
  USER_ADD_ADDRESS_SUCCESS,
  USER_ADD_ADDRESS_FAILURE,
  USER_DELETE_ADDRESS_REQUEST,
  USER_DELETE_ADDRESS_SUCCESS,
  USER_DELETE_ADDRESS_FAILURE,
  SET_DELIVERY_PLACE,
  USER_SEND_VERIFY_EMAIL_REQUEST,
  USER_SEND_VERIFY_EMAIL_SUCCESS,
  USER_SEND_VERIFY_EMAIL_FAILURE,
  USER_VERIFY_EMAIL_SUCCESS,
  PROMO_IMAGE_FAILURE,
  PROMO_IMAGE_SUCCESS,

USER_FB_SIGNUP_REQUEST ,
 USER_FB_SIGNUP_SUCCESS,
USER_FB_SIGNUP_FAILURE ,
USER_GOOGLE_SIGNUP_REQUEST ,
 USER_GOOGLE_SIGNUP_SUCCESS,
USER_GOOGLE_SIGNUP_FAILURE ,
  USER_VERIFY_OTP_REQUEST,
  USER_VERIFY_OTP_SUCCESS,
  USER_VERIFY_OTP_FAILURE,
  USER_SEND_VERIFY_OTP_REQUEST,
  USER_SEND_VERIFY_OTP_SUCCESS,
  USER_SEND_VERIFY_OTP_FAILURE
} from '../actions/userActions';

// Initial state
const initialState = fromJS({loading: false, error: {}, user: false, addresses: [], deliveryPlace: false});

// Reducer
export default function UsersReducer(state = initialState, action = {}) {

  let addresses = state.get('addresses');

  switch (action.type) {

    case USER_LOGIN_REQUEST:
    case USER_GET_PROFILE_REQUEST:
    case USER_CHANGE_PASSWORD_REQUEST:
    case USER_SAVE_PROFILE_REQUEST:
    case USER_SIGNUP_REQUEST:
    case USER_GOOGLE_SIGNUP_REQUEST:
    case USER_FB_SIGNUP_REQUEST :
    case USER_NEWSLETTER_REQUEST:
    case USER_RESET_PASSWORD_REQUEST:
    case USER_ADD_ADDRESS_REQUEST:
    case USER_DELETE_ADDRESS_REQUEST:
    case USER_VERIFY_OTP_REQUEST:
    case USER_SEND_VERIFY_OTP_REQUEST:
    case USER_SEND_VERIFY_EMAIL_REQUEST:
      return state.set('error', false).set('loading', true);

    case USER_LOGIN_SUCCESS:
    case USER_GET_PROFILE_SUCCESS:
    case USER_SAVE_PROFILE_SUCCESS:
    case USER_SIGNUP_SUCCESS:
    case USER_GOOGLE_SIGNUP_SUCCESS:
    case USER_FB_SIGNUP_SUCCESS:
    case USER_NEWSLETTER_SUCCESS:
    case USER_VERIFY_EMAIL_SUCCESS:
    case USER_VERIFY_OTP_SUCCESS:
    case USER_SEND_VERIFY_OTP_SUCCESS:
    case USER_SEND_VERIFY_EMAIL_SUCCESS:
      return state.set('user', action.payload).set('loading', false);

    case USER_ADD_ADDRESS_SUCCESS:
      return state.set('addresses', action.payload).set('loading', false);

    case USER_CHANGE_PASSWORD_SUCCESS:
    case USER_RESET_PASSWORD_SUCCESS:
    case USER_DELETE_ADDRESS_SUCCESS:
      return state.set('loading', false);

    case USER_RESET_DATA:
      return state.set('user', false);

      case SET_DELIVERY_PLACE:
        return state.set('deliveryPlace', action.payload);
    
    case PROMO_IMAGE_SUCCESS:
      return state.set('promoImage', action.payload);

    case USER_LOGIN_FAILURE:
    case USER_GET_PROFILE_FAILURE:
    case USER_SAVE_PROFILE_FAILURE:
    case USER_CHANGE_PASSWORD_FAILURE:
    case USER_SIGNUP_FAILURE:
    case USER_GOOGLE_SIGNUP_FAILURE:
    case USER_FB_SIGNUP_FAILURE:
    case USER_NEWSLETTER_FAILURE:
    case USER_RESET_PASSWORD_FAILURE:
    case USER_ADD_ADDRESS_FAILURE:
    case USER_DELETE_ADDRESS_FAILURE:
    case PROMO_IMAGE_FAILURE:
    case USER_VERIFY_OTP_FAILURE:
    case USER_SEND_VERIFY_OTP_FAILURE:
    case USER_SEND_VERIFY_EMAIL_FAILURE:
      return state.set('error', action.payload).set('loading', false)

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/usersReducer.js